(function () {
  'use strict';

  var ROOT_SELECTOR = '[data-ecomhard-videocommerce]';

  if (window.__ecomhardVideocommerceBooted) {
    if (typeof window.__ecomhardVideocommerceInit === 'function') {
      window.__ecomhardVideocommerceInit(document);
    }
    return;
  }
  window.__ecomhardVideocommerceBooted = true;

  var instances = new WeakMap();

  function safeJSON(value, fallback) {
    try { return JSON.parse(value); } catch (e) { return fallback; }
  }

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function sourceUrl(source) {
    if (!source) return '';
    return source.url || source.src || source.source || source.file_url || source.fileUrl || '';
  }

  function orderSources(sources, maxHeight) {
    if (!Array.isArray(sources) || !sources.length) return [];

    var usable = sources.map(function (source) {
      if (!source) return null;
      var url = sourceUrl(source);
      if (!url) return null;
      return {
        url: url,
        mimeType: source.mimeType || source.mime_type || source.type || '',
        format: source.format || '',
        width: Number(source.width) || 0,
        height: Number(source.height) || 0
      };
    }).filter(Boolean);

    if (!usable.length) return [];

    var mp4 = usable.filter(function (source) {
      return source.mimeType === 'video/mp4' ||
        source.format === 'mp4' ||
        /\.mp4(?:\?|$)/i.test(source.url);
    });
    if (mp4.length) usable = mp4;

    usable.sort(function (a, b) {
      var ah = a.height || 99999;
      var bh = b.height || 99999;
      var aOver = ah > maxHeight ? 1 : 0;
      var bOver = bh > maxHeight ? 1 : 0;

      if (aOver !== bOver) return aOver - bOver;

      if (!aOver && !bOver) return bh - ah;

      return Math.abs(ah - maxHeight) - Math.abs(bh - maxHeight);
    });

    return usable;
  }

  function pickSource(sources, maxHeight) {
    var ordered = orderSources(sources, maxHeight);
    return ordered.length ? ordered[0].url : '';
  }

  function formatMoney(cents, format) {
    var amount = Math.round(Number(cents) || 0);
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      try { return window.Shopify.formatMoney(amount, format || window.money_format); } catch (e) {}
    }
    try {
      return (amount / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    } catch (e) {
      return 'R$ ' + (amount / 100).toFixed(2).replace('.', ',');
    }
  }

  function EcomhardVideocommerce(root) {
    this.root = root;
    this.sectionId = root.dataset.sectionId || '';
    this.videoCount = Number(root.dataset.videoCount) || 0;
    this.loopPreviews = root.dataset.loopPreviews === 'true';
    this.productShop = root.closest('.product-shop') || document.querySelector('.product-shop');
    this.hoverCapable = !!(window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches);

    this.rail = root.querySelector('[data-vc-rail]');
    this.tiles = this.rail ? Array.prototype.slice.call(this.rail.querySelectorAll('[data-vc-open]')) : [];
    this.railPrev = root.querySelector('[data-vc-rail-prev]');
    this.railNext = root.querySelector('[data-vc-rail-next]');
    this.railArrows = root.querySelector('[data-vc-arrows]');
    this.progress = root.querySelector('[data-vc-progress]');
    this.progressThumb = root.querySelector('[data-vc-progress-thumb]');
    this.modal = root.querySelector('[data-vc-modal]');
    this.viewport = this.modal && this.modal.querySelector('[data-vc-shorts-viewport]');
    this.slides = this.modal ? Array.prototype.slice.call(this.modal.querySelectorAll('[data-vc-short-slide]')) : [];
    this.shortVideos = this.modal ? Array.prototype.slice.call(this.modal.querySelectorAll('[data-vc-short-video]')) : [];
    this.videos = this.shortVideos.map(function (video) {
      var sources = Array.prototype.slice.call(video.querySelectorAll('[data-vc-source]')).map(function (source) {
        return {
          url: source.dataset.src || '',
          mimeType: source.dataset.type || '',
          format: source.dataset.format || '',
          width: Number(source.dataset.width) || 0,
          height: Number(source.dataset.height) || 0
        };
      });
      return {
        sources: sources,
        poster: video.dataset.vcPoster || ''
      };
    });
    this.pausedButtons = this.modal ? Array.prototype.slice.call(this.modal.querySelectorAll('[data-vc-toggle-play]')) : [];
    this.closeButton = this.modal && this.modal.querySelector('[data-vc-close]');
    this.prevButton = this.modal && this.modal.querySelector('[data-vc-prev]');
    this.nextButton = this.modal && this.modal.querySelector('[data-vc-next]');
    this.muteButton = this.modal && this.modal.querySelector('[data-vc-mute]');
    this.shareButton = this.modal && this.modal.querySelector('[data-vc-share]');
    this.whatsappButton = this.modal && this.modal.querySelector('[data-vc-whatsapp]');
    this.cardImage = this.modal && this.modal.querySelector('[data-vc-product-image]');
    this.cardPrice = this.modal && this.modal.querySelector('[data-vc-price]');
    this.cardInstallment = this.modal && this.modal.querySelector('[data-vc-installment]');
    this.cardPix = this.modal && this.modal.querySelector('[data-vc-pix]');
    this.toast = this.modal && this.modal.querySelector('[data-vc-toast]');

    this.activeIndex = 0;
    this.isOpen = false;
    this.isMuted = false;
    this.rootIsNear = false;
    this.previewVideos = new Map();
    this.bodyScrollY = 0;
    this.toastTimer = null;
    this.modalMoved = false;
    this.observers = [];
    this.cleanupFns = [];
    this.bodyLockState = null;
    this.previewStartTimer = null;
    this.shortSourceCursor = {};

    this.init();
  }

  EcomhardVideocommerce.prototype.on = function (target, event, handler, options) {
    if (!target) return;
    target.addEventListener(event, handler, options);
    this.cleanupFns.push(function () { target.removeEventListener(event, handler, options); });
  };

  EcomhardVideocommerce.prototype.init = function () {
    if (!this.rail || !this.videoCount) return;

    this.setupRail();
    this.setupPreviewBehavior();
    if (this.modal) {
      this.setupModal();
      this.setupProductSync();
    }

    this.updateRailState();
    this.updateProgress();

    var self = this;
    window.requestAnimationFrame(function () {
      self.updateRailState();
      self.updateProgress();
    });
    window.setTimeout(function () {
      self.updateRailState();
      self.updateProgress();
    }, 150);
  };

  EcomhardVideocommerce.prototype.setupRail = function () {
    var self = this;

    this.on(this.rail, 'scroll', function () {
      self.updateProgress();
      self.updateRailArrows();
    }, { passive: true });

    this.on(window, 'resize', function () {
      self.updateRailState();
      self.updateProgress();
    }, { passive: true });

    this.on(this.railPrev, 'click', function (event) {
      event.preventDefault();
      self.scrollRail(-1);
    });
    this.on(this.railNext, 'click', function (event) {
      event.preventDefault();
      self.scrollRail(1);
    });

    this.tiles.forEach(function (tile) {
      var index = Number(tile.dataset.vcOpen) || 0;

      self.on(tile, 'click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        self.open(index);
      });

      if (self.hoverCapable && index > 0) {
        self.on(tile, 'mouseenter', function () {
          if (self.loopPreviews && !self.isOpen) self.startPreview(index, false);
        });
        self.on(tile, 'mouseleave', function () {
          self.stopPreview(index);
          if (self.rootIsNear && self.loopPreviews && !self.isOpen) self.startPreview(0, true);
        });
      }
    });


    // Arraste manual por mouse removido intencionalmente.
    // O trilho usa scroll nativo no touch/trackpad e as setas no desktop.
    // Isso evita pointer capture prender o cursor e bloquear o clique que abre o Shorts.
  };

  EcomhardVideocommerce.prototype.getPerView = function () {
    var value = parseFloat(getComputedStyle(this.root).getPropertyValue('--vc-per-view'));
    return value > 0 ? value : 1;
  };

  EcomhardVideocommerce.prototype.getRailStep = function () {
    var tile = this.tiles[0];
    if (!tile) return this.rail ? this.rail.clientWidth : 0;
    var width = tile.getBoundingClientRect().width;
    var styles = getComputedStyle(this.rail);
    var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
    return width + gap;
  };

  EcomhardVideocommerce.prototype.scrollRail = function (direction) {
    if (!this.rail || this.rail.classList.contains('is-no-overflow')) return;
    var amount = this.getRailStep() * direction;
    if (typeof this.rail.scrollBy === 'function') {
      this.rail.scrollBy({ left: amount, behavior: 'smooth' });
    } else {
      this.rail.scrollLeft += amount;
    }
  };

  EcomhardVideocommerce.prototype.updateRailState = function () {
    if (!this.rail) return;
    var noOverflowByCount = this.videoCount <= this.getPerView();
    this.rail.classList.toggle('is-no-overflow', noOverflowByCount);
    var noOverflow = noOverflowByCount || this.rail.scrollWidth <= this.rail.clientWidth + 2;
    if (this.progress) this.progress.classList.toggle('is-hidden', noOverflow);
    if (this.railArrows) this.railArrows.classList.toggle('is-hidden', noOverflow);
    this.updateRailArrows();
  };

  EcomhardVideocommerce.prototype.updateRailArrows = function () {
    if (!this.rail) return;
    var max = Math.max(0, this.rail.scrollWidth - this.rail.clientWidth);
    var current = Math.max(0, this.rail.scrollLeft);
    var noOverflow = max <= 2 || this.rail.classList.contains('is-no-overflow');
    if (this.railPrev) this.railPrev.disabled = noOverflow || current <= 2;
    if (this.railNext) this.railNext.disabled = noOverflow || current >= max - 2;
  };

  EcomhardVideocommerce.prototype.updateProgress = function () {
    if (!this.rail || !this.progressThumb || !this.progress) {
      this.updateRailArrows();
      return;
    }
    var max = Math.max(0, this.rail.scrollWidth - this.rail.clientWidth);
    var ratio = this.rail.scrollWidth ? this.rail.clientWidth / this.rail.scrollWidth : 1;
    var thumb = clamp(ratio * 100, 20, 100);
    var progress = max > 0 ? clamp(this.rail.scrollLeft / max, 0, 1) : 0;
    this.progressThumb.style.width = thumb + '%';
    this.progressThumb.style.left = (progress * (100 - thumb)) + '%';
    this.progress.classList.toggle('is-hidden', max <= 2 || this.videoCount <= this.getPerView());
    this.updateRailArrows();
  };

  EcomhardVideocommerce.prototype.isRootNearViewport = function () {
    if (!this.root || !this.root.getBoundingClientRect) return false;
    var rect = this.root.getBoundingClientRect();
    var margin = 260;
    return rect.bottom >= -margin && rect.top <= (window.innerHeight || document.documentElement.clientHeight) + margin;
  };

  EcomhardVideocommerce.prototype.setupPreviewBehavior = function () {
    var self = this;
    if (!this.loopPreviews) return;

    var activateFirstIfNear = function () {
      self.rootIsNear = self.isRootNearViewport();
      if (self.rootIsNear && !self.isOpen && !document.hidden) self.startPreview(0, true);
      else self.stopPreview(0);
    };

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.target !== self.root) return;
          self.rootIsNear = entry.isIntersecting || self.isRootNearViewport();
          if (self.rootIsNear && !self.isOpen && !document.hidden) self.startPreview(0, true);
          else self.stopPreview(0);
        });
      }, { root: null, rootMargin: '260px 0px', threshold: 0 });
      observer.observe(this.root);
      this.observers.push(observer);
    } else {
      this.on(window, 'scroll', activateFirstIfNear, { passive: true });
    }

    this.on(document, 'visibilitychange', function () {
      if (document.hidden) self.stopAllPreviews();
      else activateFirstIfNear();
    });

    this.previewStartTimer = window.setTimeout(activateFirstIfNear, 80);
  };

  EcomhardVideocommerce.prototype.startPreview = function (index, isAutomatic) {
    if (!this.loopPreviews || this.isOpen || document.hidden) return;
    if (!this.videos[index]) return;

    this.stopAllPreviews(index);
    if (this.previewVideos.has(index)) return;

    var host = this.root.querySelector('[data-vc-preview-host="' + index + '"]');
    if (!host) return;

    var source = pickSource(this.videos[index].sources, 480);
    if (!source) return;

    var video = document.createElement('video');
    video.className = 'ecomhard-videocommerce__preview-video';
    video.muted = true;
    video.defaultMuted = true;
    video.autoplay = true;
    video.playsInline = true;
    video.setAttribute('muted', '');
    video.setAttribute('autoplay', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    video.setAttribute('aria-hidden', 'true');
    video.preload = 'auto';
    video.src = source;

    var self = this;
    var tryPlay = function () {
      if (!video.isConnected || self.isOpen || document.hidden) return;
      var promise;
      try { promise = video.play(); } catch (e) { return; }
      if (promise && typeof promise.catch === 'function') promise.catch(function () {});
    };

    video.addEventListener('playing', function () {
      if (video.isConnected) host.classList.add('is-previewing');
    });
    video.addEventListener('canplay', tryPlay);
    video.addEventListener('loadeddata', tryPlay);
    video.addEventListener('timeupdate', function () {
      if (video.currentTime >= 5) {
        try { video.currentTime = 0; } catch (e) {}
        tryPlay();
      }
    });
    video.addEventListener('ended', function () {
      try { video.currentTime = 0; } catch (e) {}
      tryPlay();
    });

    host.appendChild(video);
    this.previewVideos.set(index, { video: video, host: host, auto: !!isAutomatic });
    try { video.load(); } catch (e) {}
    tryPlay();
    window.setTimeout(tryPlay, 120);
  };

  EcomhardVideocommerce.prototype.stopPreview = function (index) {
    var item = this.previewVideos.get(index);
    if (!item) return;
    try { item.video.pause(); } catch (e) {}
    item.video.removeAttribute('src');
    try { item.video.load(); } catch (e) {}
    if (item.video.parentNode) item.video.parentNode.removeChild(item.video);
    item.host.classList.remove('is-previewing');
    this.previewVideos.delete(index);
  };

  EcomhardVideocommerce.prototype.stopAllPreviews = function (exceptIndex) {
    var self = this;
    Array.from(this.previewVideos.keys()).forEach(function (index) {
      if (index !== exceptIndex) self.stopPreview(index);
    });
  };

  EcomhardVideocommerce.prototype.setupModal = function () {
    var self = this;
    this.moveModalToBody();

    this.on(this.closeButton, 'click', function (event) { event.preventDefault(); self.close(); });
    this.on(this.prevButton, 'click', function (event) { event.preventDefault(); self.goTo(self.activeIndex - 1); });
    this.on(this.nextButton, 'click', function (event) { event.preventDefault(); self.goTo(self.activeIndex + 1); });
    this.on(this.muteButton, 'click', function (event) { event.preventDefault(); self.toggleMute(); });
    this.on(this.shareButton, 'click', function (event) { event.preventDefault(); self.share(); });

    if (this.whatsappButton) {
      var message = 'Olá, estou no produto ' + (this.root.dataset.productTitle || '') + ' e gostaria de falar com um vendedor';

      // Usa o protocolo nativo do WhatsApp em vez de wa.me.
      // Assim o navegador permanece na PDP e exibe o aviso nativo
      // de confirmação para abrir o aplicativo quando suportado.
      this.whatsappButton.href = 'whatsapp://send?phone=5531997519001&text=' + encodeURIComponent(message);
      this.whatsappButton.removeAttribute('target');
      this.whatsappButton.removeAttribute('rel');
    }

    this.on(this.modal, 'click', function (event) {
      if (event.target === self.modal) self.close();
      var playToggle = event.target.closest && event.target.closest('[data-vc-toggle-play]');
      if (playToggle) self.togglePlay();
    });

    this.shortVideos.forEach(function (video, index) {
      self.on(video, 'click', function () { self.togglePlay(); });
      self.on(video, 'play', function () { self.updatePausedState(false); });
      self.on(video, 'pause', function () {
        if (self.isOpen && video === self.shortVideos[self.activeIndex]) self.updatePausedState(true);
      });
      self.on(video, 'error', function () {
        if (!self.isOpen || index !== self.activeIndex) return;
        self.tryNextShortSource(index);
      });
    });

    this.on(document, 'keydown', function (event) {
      if (!self.isOpen) return;
      if (event.key === 'Escape') self.close();
      if (event.key === 'ArrowUp') { event.preventDefault(); self.goTo(self.activeIndex - 1); }
      if (event.key === 'ArrowDown') { event.preventDefault(); self.goTo(self.activeIndex + 1); }
      if (event.key === ' ' && !/INPUT|TEXTAREA|BUTTON|A/.test((event.target && event.target.tagName) || '')) {
        event.preventDefault();
        self.togglePlay();
      }
    });

    if ('IntersectionObserver' in window && this.viewport) {
      var observer = new IntersectionObserver(function (entries) {
        if (!self.isOpen) return;
        var best = null;
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          if (!best || entry.intersectionRatio > best.intersectionRatio) best = entry;
        });
        if (best && best.intersectionRatio >= 0.5) {
          var index = Number(best.target.dataset.vcShortSlide) || 0;
          if (index !== self.activeIndex) self.setActive(index, true);
        }
      }, { root: this.viewport, threshold: [0.5, 0.7, 0.85] });
      this.slides.forEach(function (slide) { observer.observe(slide); });
      this.observers.push(observer);
    }

    if (this.viewport) {
      var scrollTimer;
      this.on(this.viewport, 'scroll', function () {
        if (!self.isOpen) return;
        window.clearTimeout(scrollTimer);
        scrollTimer = window.setTimeout(function () {
          var viewportTop = self.viewport.getBoundingClientRect().top;
          var closest = 0;
          var distance = Infinity;
          self.slides.forEach(function (slide, index) {
            var d = Math.abs(slide.getBoundingClientRect().top - viewportTop);
            if (d < distance) { distance = d; closest = index; }
          });
          if (closest !== self.activeIndex) self.setActive(closest, true);
        }, 70);
      }, { passive: true });
    }
  };

  EcomhardVideocommerce.prototype.moveModalToBody = function () {
    if (!this.modal) return;
    if (this.modal.parentNode !== document.body) document.body.appendChild(this.modal);
    this.modalMoved = true;
  };

  EcomhardVideocommerce.prototype.lockBody = function () {
    if (this.bodyLockState) return;
    this.bodyScrollY = window.scrollY || window.pageYOffset || 0;
    this.bodyLockState = {
      htmlOverflow: document.documentElement.style.overflow,
      bodyOverflow: document.body.style.overflow,
      bodyOverscroll: document.body.style.overscrollBehavior
    };
    document.documentElement.classList.add('ecomhard-shorts-open');
    document.body.classList.add('ecomhard-shorts-open');
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    document.body.style.overscrollBehavior = 'none';
  };

  EcomhardVideocommerce.prototype.unlockBody = function () {
    document.documentElement.classList.remove('ecomhard-shorts-open');
    document.body.classList.remove('ecomhard-shorts-open');
    if (this.bodyLockState) {
      document.documentElement.style.overflow = this.bodyLockState.htmlOverflow || '';
      document.body.style.overflow = this.bodyLockState.bodyOverflow || '';
      document.body.style.overscrollBehavior = this.bodyLockState.bodyOverscroll || '';
      this.bodyLockState = null;
    }
  };

  EcomhardVideocommerce.prototype.open = function (index) {
    if (!this.modal || !this.slides.length) return;
    index = clamp(Number(index) || 0, 0, this.slides.length - 1);
    this.stopAllPreviews();
    this.moveModalToBody();
    this.syncProductCard();

    // Cada nova abertura começa com áudio ligado. Navegação entre Shorts preserva
    // a escolha do usuário até o modal ser fechado.
    this.isMuted = false;
    this.updateMuteState();

    this.isOpen = true;
    this.modal.hidden = false;
    this.modal.removeAttribute('hidden');
    this.modal.setAttribute('aria-hidden', 'false');
    this.modal.classList.add('is-open');

    // Primeiro tornamos o Shorts visível; só depois bloqueamos o scroll da página.
    // Evita a sensação de página "presa" caso algum CSS do tema interfira no modal.
    this.lockBody();

    this.activeIndex = index;
    this.setActive(index, false);

    var self = this;
    window.requestAnimationFrame(function () {
      if (self.viewport && self.slides[index]) self.viewport.scrollTop = self.slides[index].offsetTop;
      self.setActive(index, false);
      if (self.closeButton) {
        try { self.closeButton.focus({ preventScroll: true }); } catch (e) { self.closeButton.focus(); }
      }
    });
  };

  EcomhardVideocommerce.prototype.close = function () {
    if (!this.isOpen) return;
    this.isOpen = false;
    this.unloadAllShorts();
    this.modal.classList.remove('is-open');
    this.modal.hidden = true;
    this.modal.setAttribute('hidden', '');
    this.modal.setAttribute('aria-hidden', 'true');
    this.unlockBody();
    this.updatePausedState(false);
    if (this.rootIsNear && this.loopPreviews) this.startPreview(0, true);
  };

  EcomhardVideocommerce.prototype.goTo = function (index) {
    if (!this.isOpen || !this.slides.length) return;
    index = clamp(index, 0, this.slides.length - 1);
    if (index === this.activeIndex) return;
    var slide = this.slides[index];
    if (this.viewport && slide) {
      if (typeof this.viewport.scrollTo === 'function') this.viewport.scrollTo({ top: slide.offsetTop, behavior: 'smooth' });
      else this.viewport.scrollTop = slide.offsetTop;
    }
    this.setActive(index, false);
  };

  EcomhardVideocommerce.prototype.setActive = function (index, fromScroll) {
    index = clamp(Number(index) || 0, 0, this.slides.length - 1);
    this.activeIndex = index;

    for (var i = 0; i < this.shortVideos.length; i++) {
      if (i === index) this.loadAndPlayShort(i);
      else this.unloadShort(i);
    }

    if (this.prevButton) this.prevButton.disabled = index <= 0;
    if (this.nextButton) this.nextButton.disabled = index >= this.slides.length - 1;

    if (!fromScroll && this.viewport && this.slides[index]) {
      var expected = this.slides[index].offsetTop;
      if (Math.abs(this.viewport.scrollTop - expected) > 3) this.viewport.scrollTop = expected;
    }
  };

  EcomhardVideocommerce.prototype.applyShortSource = function (index, cursor) {
    var video = this.shortVideos[index];
    var data = this.videos[index];
    if (!video || !data) return false;

    var ordered = orderSources(data.sources, 720);
    if (!ordered.length) return false;

    cursor = clamp(Number(cursor) || 0, 0, ordered.length - 1);
    var candidate = ordered[cursor];
    if (!candidate || !candidate.url) return false;

    try { video.pause(); } catch (e) {}
    video.removeAttribute('src');
    try { video.load(); } catch (e) {}

    video.src = candidate.url;
    video.dataset.loadedSrc = candidate.url;
    video.dataset.sourceCursor = String(cursor);
    this.shortSourceCursor[index] = cursor;

    video.preload = 'auto';
    video.playsInline = true;
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');

    if (data.poster) {
      video.poster = data.poster;
      video.setAttribute('poster', data.poster);
    }

    try { video.load(); } catch (e) {}
    return true;
  };

  EcomhardVideocommerce.prototype.tryNextShortSource = function (index) {
    var data = this.videos[index];
    var video = this.shortVideos[index];
    if (!data || !video) return;

    var ordered = orderSources(data.sources, 720);
    var cursor = Number(video.dataset.sourceCursor || this.shortSourceCursor[index] || 0);
    if (cursor + 1 >= ordered.length) {
      this.updatePausedState(true);
      return;
    }

    if (this.applyShortSource(index, cursor + 1)) {
      this.playShort(index);
    }
  };

  EcomhardVideocommerce.prototype.playShort = function (index) {
    var video = this.shortVideos[index];
    if (!video) return;

    video.muted = this.isMuted;
    video.defaultMuted = this.isMuted;

    var self = this;
    var attempt = function () {
      if (!self.isOpen || self.activeIndex !== index) return;
      var promise;
      try { promise = video.play(); } catch (e) { return; }
      if (promise && typeof promise.catch === 'function') {
        promise.catch(function () {
          video.muted = true;
          video.defaultMuted = true;
          self.isMuted = true;
          self.updateMuteState();

          try {
            var retry = video.play();
            if (retry && typeof retry.catch === 'function') {
              retry.catch(function () { self.updatePausedState(true); });
            }
          } catch (e) {
            self.updatePausedState(true);
          }
        });
      }
    };

    if (video.readyState >= 2) {
      attempt();
    } else {
      video.addEventListener('loadeddata', attempt, { once: true });
      video.addEventListener('canplay', attempt, { once: true });
    }

    attempt();
  };

  EcomhardVideocommerce.prototype.loadAndPlayShort = function (index) {
    var video = this.shortVideos[index];
    var data = this.videos[index];
    if (!video || !data) return;

    if (data.poster && !video.getAttribute('poster')) {
      video.poster = data.poster;
      video.setAttribute('poster', data.poster);
    }

    if (!video.dataset.loadedSrc) {
      if (!this.applyShortSource(index, 0)) return;
    }

    this.playShort(index);
  };

  EcomhardVideocommerce.prototype.unloadShort = function (index) {
    var video = this.shortVideos[index];
    if (!video || !video.dataset.loadedSrc) return;
    try { video.pause(); } catch (e) {}
    video.removeAttribute('src');
    video.removeAttribute('poster');
    delete video.dataset.loadedSrc;
    delete video.dataset.sourceCursor;
    delete this.shortSourceCursor[index];
    try { video.load(); } catch (e) {}
  };

  EcomhardVideocommerce.prototype.unloadAllShorts = function () {
    for (var i = 0; i < this.shortVideos.length; i++) this.unloadShort(i);
  };

  EcomhardVideocommerce.prototype.togglePlay = function () {
    var video = this.shortVideos[this.activeIndex];
    if (!video) return;
    if (video.paused) {
      try {
        var promise = video.play();
        if (promise && typeof promise.catch === 'function') promise.catch(function () {});
      } catch (e) {}
    } else {
      video.pause();
    }
  };

  EcomhardVideocommerce.prototype.updatePausedState = function (paused) {
    var self = this;
    this.pausedButtons.forEach(function (button, index) {
      var show = !!paused && index === self.activeIndex;
      button.hidden = !show;
      button.setAttribute('aria-label', show ? 'Reproduzir vídeo' : 'Pausar vídeo');
    });
  };

  EcomhardVideocommerce.prototype.toggleMute = function () {
    this.isMuted = !this.isMuted;
    var video = this.shortVideos[this.activeIndex];
    if (video) {
      video.muted = this.isMuted;
      video.defaultMuted = this.isMuted;
    }
    this.updateMuteState();
  };

  EcomhardVideocommerce.prototype.updateMuteState = function () {
    if (!this.muteButton) return;
    this.muteButton.setAttribute('aria-pressed', this.isMuted ? 'true' : 'false');
    this.muteButton.setAttribute('aria-label', this.isMuted ? 'Ativar som' : 'Mutar vídeo');
  };

  EcomhardVideocommerce.prototype.showToast = function (message) {
    var self = this;
    if (!this.toast) return;
    window.clearTimeout(this.toastTimer);
    this.toast.textContent = message;
    this.toast.classList.add('is-visible');
    this.toastTimer = window.setTimeout(function () { self.toast.classList.remove('is-visible'); }, 1800);
  };

  EcomhardVideocommerce.prototype.share = function () {
    var self = this;
    var data = {
      title: this.root.dataset.productTitle || document.title,
      text: this.root.dataset.productTitle || '',
      url: this.root.dataset.productUrl || window.location.href
    };

    if (navigator.share) {
      navigator.share(data).catch(function () {});
      return;
    }

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(data.url).then(function () { self.showToast('Link copiado'); }).catch(function () {});
      return;
    }

    var input = document.createElement('input');
    input.value = data.url;
    document.body.appendChild(input);
    input.select();
    try { document.execCommand('copy'); self.showToast('Link copiado'); } catch (e) {}
    document.body.removeChild(input);
  };

  EcomhardVideocommerce.prototype.setupProductSync = function () {
    var self = this;
    var productShop = this.productShop;
    if (!productShop) return;

    var priceNode = productShop.querySelector('.price:not(.nao-atualizar)');
    if ('MutationObserver' in window && priceNode) {
      var observer = new MutationObserver(function () { self.syncProductCard(); });
      observer.observe(priceNode, { childList: true, subtree: true, characterData: true });
      this.observers.push(observer);
    }

    this.on(productShop, 'change', function () {
      window.setTimeout(function () { self.syncProductCard(); }, 30);
    });
  };

  EcomhardVideocommerce.prototype.getCurrentPrice = function () {
    var productShop = this.productShop;
    var input = productShop && productShop.querySelector('#product_regular_price:not(.nao-atualizar)');
    var value = input ? Number(input.value) : Number(this.root.dataset.price);
    return isFinite(value) && value >= 0 ? value : 0;
  };

  EcomhardVideocommerce.prototype.getCurrentImage = function () {
    var productShop = this.productShop;
    var select = productShop && productShop.querySelector('#product-selectors');
    var option = select && select.options ? select.options[select.selectedIndex] : null;
    var fromVariant = option && (option.dataset.imge || option.getAttribute('data-imge'));
    return fromVariant || this.root.dataset.productImage || '';
  };

  EcomhardVideocommerce.prototype.syncProductCard = function () {
    var price = this.getCurrentPrice();
    var installments = Math.max(1, Number(this.root.dataset.installments) || 1);
    var pixPercent = Number(this.root.dataset.pixPercent) || 0;
    var format = this.root.dataset.moneyFormat || window.money_format;

    if (this.cardPrice) this.cardPrice.textContent = formatMoney(price, format);
    if (this.cardInstallment) this.cardInstallment.textContent = installments + 'x de ' + formatMoney(Math.round(price / installments), format);
    if (this.cardPix) this.cardPix.textContent = formatMoney(Math.round(price * (100 - pixPercent) / 100), format) + ' (' + pixPercent + '% no PIX)';

    var image = this.getCurrentImage();
    if (this.cardImage && image && this.cardImage.getAttribute('src') !== image) this.cardImage.src = image;
  };

  EcomhardVideocommerce.prototype.destroy = function () {
    window.clearTimeout(this.previewStartTimer);
    this.stopAllPreviews();
    this.unloadAllShorts();
    if (this.isOpen) this.unlockBody();
    this.isOpen = false;

    this.observers.forEach(function (observer) {
      if (observer && typeof observer.disconnect === 'function') observer.disconnect();
    });
    this.observers = [];

    this.cleanupFns.forEach(function (fn) {
      try { fn(); } catch (e) {}
    });
    this.cleanupFns = [];

    if (this.modalMoved && this.modal && this.modal.parentNode) this.modal.parentNode.removeChild(this.modal);
    this.root.removeAttribute('data-vc-initialized');
    instances.delete(this.root);
  };

  function initWithin(scope) {
    var container = scope || document;
    var roots = [];
    if (container.matches && container.matches(ROOT_SELECTOR)) roots.push(container);
    if (container.querySelectorAll) roots = roots.concat(Array.prototype.slice.call(container.querySelectorAll(ROOT_SELECTOR)));

    roots.forEach(function (root) {
      if (root.dataset.vcInitialized === 'true') return;
      root.dataset.vcInitialized = 'true';
      var instance = new EcomhardVideocommerce(root);
      instances.set(root, instance);
    });
  }

  window.__ecomhardVideocommerceInit = initWithin;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initWithin(document); }, { once: true });
  } else {
    initWithin(document);
  }

  document.addEventListener('shopify:section:load', function (event) { initWithin(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    var roots = event.target && event.target.querySelectorAll ? event.target.querySelectorAll(ROOT_SELECTOR) : [];
    Array.prototype.forEach.call(roots, function (root) {
      var instance = instances.get(root);
      if (instance) instance.destroy();
    });
  });
})();
